export default {
    getBanner: (data) => window.axios.post('get_banner', data),
    getBannerCategory: (data) => window.axios.post('banner_with_category', data)
}